import angular from 'angular';
import Logger from '../../../shared/logger';

export const escKey = () => function (scope, element) {
    if (!element || element.length > 0) return;
    element.bind('keydown keypress', (event) => {
        if (event.which === 27) {
            // 27 = esc key
            event.preventDefault();
        }
    });
    window.addEventListener('blur', () => {
        try {
            element.click();
        } catch (err) {
            Logger.error(err);
        }
    });

    window.onhashchange = function () {
        try {
            element.click();
        } catch (err) {
            Logger.error(err);
        }
    };
};

angular
    .module('TALENYA-FE')
    .directive('escKey', escKey);
